import _ToolBar from '../ToolBar.jsx'
import MenuButtonDpList from './MenuButtonDpList.jsx'

export default function ToolBar(props) {
    return (
        <_ToolBar {...props}>
            <div></div>

            <div>
                <MenuButtonDpList />
            </div>
        </_ToolBar>
    )
}
